export default function machineDisplayName(machine) {
  const serial = String(machine.SerialNumber ?? "").trim();
  const name = String(machine.Name ?? "").trim();
  return [serial, name].filter(Boolean).join(" · ") || "—";
}
